<template>
  <v-theme-provider light>
    <v-select
      ref="select"
      :value="value"
      @input="$emit('input', $event)"
      @click="onSelectClick"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      return-object
      solo
      background-color="white"
      color="black"
      class="light-select--spartan"
      :class="{ 'is-open': isOpen }"
      :menu-props="menuProps"
    >
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on" class="light-select-item--spartan" :ripple="false">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon v-if="isSelected(item)">
            <v-icon small>mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </template>
    </v-select>
  </v-theme-provider>
</template>

<script>
export default {
  name: 'CharitySelect',
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: [Object, String, Number],
      default: null,
    },
    itemText: {
      type: String,
    },
    itemValue: {
      type: String,
    },
    visibleItemCount: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      isOpen: false,
      timeooutId: null,
    };
  },
  computed: {
    menuProps() {
      const itemHeight = 42;
      return {
        light: true,
        contentClass: `light-select-menu--spartan light-select-menu--instance-${this._uid}`,
        offsetY: true,
        nudgeBottom: '8px',
        transition: false,
        maxHeight: this.visibleItemCount * itemHeight,
      };
    },
  },
  methods: {
    isSelected(item) {
      if (!this.value) return false;

      return this.value.charityId === item.charityId;
    },
    onSelectClick() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => this.measureAndApplyMenuWidth());
      }
    },
    measureAndApplyMenuWidth() {
      const inputEl = this.$refs.select?.$el;

      if (!inputEl) return;

      const width = inputEl.offsetWidth;

      const apply = () => {
        const menuEl = document.querySelector(`.light-select-menu--instance-${this._uid}`);

        if (menuEl) {
          menuEl.style.width = `${width}px`;
          menuEl.style.maxWidth = `${width}px`;
        }
      };

      this.$nextTick(apply);
      this.timeoutId = setTimeout(apply, 0);
    },
  },
  mounted() {
    this.$nextTick(() => this.measureAndApplyMenuWidth());
  },
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
};
</script>

<style lang="scss">
.light-select--spartan {

  &.v-input--is-focused {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
  }

  &.is-open {
    .v-input__control {
      border-radius: 8px 8px 0 0;
    }
  }

  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
  }

  .v-input__slot {
    border-radius: 8px;
    border: 1px solid #4B4B4B !important;
    box-shadow: none !important;
    padding: 8px !important;
  }
  
  .v-input__control {
    min-height: 42px !important;
    height: 42px;
  }

  .v-select__selection--comma {
    color: #676767;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.light-select-menu--spartan {
  &.v-menu__content {
    box-shadow: none !important;
    border-radius: 8px;
    border: 1px solid #BFBFBF;
    min-width: 0 !important;
  }

  .v-list {
    .v-list-item { 
      min-height: 42px;
      // height: 42px;
      font-size: 14px;

      .v-list-item__title {
        font-size: 14px;
        color: #676767;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        white-space: normal;
        word-break: break-word;
      }

      .v-list-item__icon {
        margin: 0;
        align-self: normal;
      }

      &:hover {
        background: #FFF8F8;
        color: #070707;

        .v-list-item__title {
          color: #070707;
        }
      }
    }
    
    .v-list-item--active  {
      color: inherit !important;
      background: transparent;

      .v-list-item__title {
        color: #070707;
      }

      &::before {
        background: transparent;
      }
    }
  }
}
</style>